import { formatPriceWithCurrencySymbol } from "../../../helpers/getPriceWithCurrencySymbol";
import BookingGetters from "../../../store/onlineBooking/getters";
import React, { useState, useEffect, useRef } from "react";
import theme from "../../../config/MuiColorThemes";
import { Button, Card } from "@mui/material";
import {
  BookingTextResource,
  TextResource,
} from "../../../@types/DTO/AppSetting";
import { useTranslation } from "react-i18next";
import AppButton from "../AppButtons";
import { CheckCircleOutlined } from "@mui/icons-material";
import { useLocation, useSearchParams } from "react-router-dom";
import { BOOKING_ACTIONS } from "../../../store/onlineBooking";
import { BookingApi } from "../../../API/Apis/BookingApi";
import i18n from "../../../config/i18n";
import { differenceInDays, differenceInHours } from "date-fns";

function VehicleExtrasWithInfo({
  iconUrl,
  optionName,
  pricePerDayInUSD,
  details,
  onDecrementClick,
  onIncrementClick,
  value,
  cardBackgroundColor,
  selectedCardBackgroundColor,
  cardTextColor,
  selectedCardTextColor,
  secondaryColor,
  fillToCard,
  maxAllowed,
  showOptionalCode,
  showOptionalDescription,
  showDescFromBookingText,
  isDailyPrice,
  doNotShowOptionalPrice,
  isNegotiableDaily,
}): JSX.Element {
  const buttonBorderStyles = "border-solid border-black-300 border-2 ";
  const isDesktopScreen = window.innerWidth >= 1310;
  const appSettings = BookingGetters.getAppSettings();
  const fontFamilyStyle = appSettings?.fontFamily;
  const lang = i18n.language;
  const textResource = BookingGetters.getTextResourceDetailsBasedOnLang();
  const data = textResource?.[lang]?.flatMap((item) => item.data || []) || [];
  const optionalObject = data.find((item) => item.key === optionName);
  const optionalBody = optionalObject ? optionalObject?.body : "";
  const { t: translate } = useTranslation();
  const [showInfo, setShowInfo] = useState(false);
  const toogleVehicleInfoCardShowingStatus = () => {
    setShowInfo(!showInfo);
  };
  const isSmallScreen = window.innerWidth <= 768;
  const defaultCurrency = appSettings?.defaultCurrency;
  const marginTopStyle =
    showDescFromBookingText && optionalBody && showOptionalDescription
      ? "2px"
      : isDesktopScreen || isSmallScreen
      ? "12px"
      : "0px";
  const isTabletScreen = window.innerWidth > 768 && window.innerWidth < 1300;
  const marginTopStyle1 =
    showDescFromBookingText && optionalBody && showOptionalDescription
      ? "10px"
      : "25px";
  //const textResourceInfo = BookingGetters.getTextResource()?.data ?? [];
  const [extrasSelectButtonLabel, setExtrasSelectButtonLabel] =
    useState<string>("");
  const [extrasRemoveButtonLabel, setExtrasRemoveButtonLabel] =
    useState<string>("");
  const BookingLang = i18n.language;
  useEffect(() => {
    const getLabel = (key) => data.find((item) => item.key === key)?.body || "";
    setExtrasSelectButtonLabel(getLabel("selectVehicleExtrasLabel"));
    setExtrasRemoveButtonLabel(
      getLabel("removeVehicleExtrasLabel") || translate("Remove")
    );
  }, [textResource, translate, BookingLang]);

  const ReservationDetails = BookingGetters.getBookingDetails();
  const [startDate] = useState(
    new Date(ReservationDetails.pickUpDateAndTime || Date.now())
  );
  const [endDate] = useState(
    new Date(ReservationDetails.dropOffDateAndTime || Date.now())
  );
  const [differenceInHour] = useState(differenceInHours(endDate, startDate));
  const approximateDays = Math.ceil(differenceInHour / 24);
  const showDailyPriceForInsuranceAndExtras =
    appSettings?.showDailyPriceForInsuranceAndExtras;
  const showDailyPriceOrNegotiableDailyPrice =
    appSettings?.showDailyPriceOrNegotiableDailyPrice;
  return (
    <>
      {maxAllowed && maxAllowed > 1 ? (
        <Card
          sx={{
            maxWidth: 550,
            borderRadius: theme.shape.borderRadius,
            boxShadow:
              "0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 6px rgba(0, 0, 0, 0.1)",
            margin: "9px",
            height: "130px",
          }}
        >
          <div
            className="flex flex-row items-center text-sm"
            style={{
              marginLeft: "6px",
              height: "55px",
              marginTop: "9px",
            }}
          >
            {iconUrl != "#" && appSettings?.showHideExtrasImages && (
              <img
                src={iconUrl}
                className="w-full aspect-square"
                style={{ width: "10%" }}
                alt={""}
              ></img>
            )}
            <main className="flex flex-col box-border grow max-w-[75%] grow text-sm relative mt-2 mb-2">
              {appSettings?.showOptionalCodeFromTextRes ? (
                <span
                  className="font-bold break-words"
                  style={
                    value > 0
                      ? { color: secondaryColor, padding: "2%" }
                      : { padding: "2%" }
                  }
                >
                  {optionalObject?.description || optionName}
                </span>
              ) : showOptionalCode ? (
                <span
                  className="font-bold break-words"
                  style={
                    value > 0
                      ? { color: secondaryColor, padding: "2%" }
                      : { padding: "2%" }
                  }
                >
                  {optionName}
                </span>
              ) : (
                ""
              )}
              {/*{showDescFromBookingText && (*/}
              {/*  <div className="flex flex-col">*/}
              {/*    <div*/}
              {/*      className="font-medium break-words ml-1 text-sm"*/}
              {/*      style={*/}
              {/*        value > 0*/}
              {/*          ? { color: secondaryColor, padding: "2%" }*/}
              {/*          : { padding: "2%" }*/}
              {/*      }*/}
              {/*    >*/}
              {/*      {optionalBody.length > 60*/}
              {/*        ? optionalBody.substring(0, 60) + "..."*/}
              {/*        : optionalBody}*/}
              {/*    </div>*/}
              {/*  </div>*/}
              {/*)}*/}
              {showOptionalDescription && (
                <span
                  className="font-bold break-words"
                  style={
                    value > 0
                      ? { color: secondaryColor, padding: "2%" }
                      : { padding: "2%" }
                  }
                >
                  {details}
                </span>
              )}
              {!showOptionalCode &&
                !showOptionalDescription &&
                !appSettings?.showOptionalCodeFromTextRes && (
                  <span
                    className="font-bold break-words"
                    style={
                      value > 0
                        ? { color: secondaryColor, padding: "2%" }
                        : { padding: "2%" }
                    }
                  >
                    {optionName}
                  </span>
                )}
            </main>
            {showDescFromBookingText && (
              <div style={{ float: "right" }}>
                <Button onClick={toogleVehicleInfoCardShowingStatus}>
                  <p
                    className="text-md capitalize text-black"
                    style={{ color: secondaryColor }}
                  >
                    Info
                  </p>
                </Button>
              </div>
            )}
          </div>
          <div
            className="flex flex-row gap-2 h-full"
            style={
              value > 0
                ? {
                    color: secondaryColor,
                    paddingLeft: "5%",
                    paddingRight: "5%",
                    paddingBottom: "5%",
                    marginTop:
                      showDescFromBookingText &&
                      showOptionalDescription &&
                      !showOptionalCode
                        ? "10px"
                        : "30px",
                    justifyContent: "space-between",
                  }
                : {
                    paddingLeft: "5%",
                    paddingRight: "5%",
                    paddingBottom: "5%",
                    marginTop:
                      showDescFromBookingText &&
                      showOptionalDescription &&
                      !showOptionalCode
                        ? "10px"
                        : "30px",
                    justifyContent: "space-between",
                  }
            }
          >
            <div className="flex gap-1">
              <span className="whitespace-nowrap">
                {!doNotShowOptionalPrice && (
                  <>
                    {defaultCurrency ||
                      formatPriceWithCurrencySymbol(
                        BookingGetters.getCurrency()
                      ).symbol}
                    {"  "}
                    {showDailyPriceForInsuranceAndExtras ? (
                      <>
                        {(
                          parseFloat(pricePerDayInUSD) / approximateDays
                        ).toFixed(2)}
                        <span>{translate("/day")}</span>
                      </>
                    ) : (showDailyPriceOrNegotiableDailyPrice &&
                        isDailyPrice) ||
                      isNegotiableDaily ? (
                      <>
                        {(
                          parseFloat(pricePerDayInUSD) / approximateDays
                        ).toFixed(2)}
                        <span>{translate("/day")}</span>
                      </>
                    ) : (
                      pricePerDayInUSD
                    )}
                  </>
                )}
              </span>
            </div>
            <div className="flex gap-1">
              <div
                onClick={() => {
                  onDecrementClick();
                }}
                style={{
                  color: value === 0 ? "lightgray" : "",
                  borderRadius: "50%",
                  borderColor: value === 0 ? "#f2eeee" : "",
                }}
                className={
                  "w-6 h-6 flex items-center text-center justify-center cursor-pointer select-none" +
                  " " +
                  buttonBorderStyles
                }
              >
                <span
                  className="w-fit h-fit"
                  style={{
                    marginBottom: isTabletScreen ? "2px" : "4px",
                  }}
                >
                  -
                </span>
              </div>
              <span className="w-6 h-6 flex items-center text-center justify-center black">
                {value}
              </span>
              <div
                onClick={() => {
                  onIncrementClick();
                }}
                className={
                  "w-6 h-6 flex items-center text-center justify-center  cursor-pointer select-none" +
                  " " +
                  buttonBorderStyles
                }
                style={{
                  backgroundColor: value > 0 ? secondaryColor : "",
                  color: value > 0 ? selectedCardTextColor : "",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  borderColor: value === 0 ? "#838181" : "",
                }}
              >
                <span
                  className="w-fit h-fit  black"
                  style={{
                    marginBottom: isTabletScreen ? "0px" : "4px",
                  }}
                >
                  +
                </span>
              </div>
            </div>
          </div>
        </Card>
      ) : (
        <Card
          className={`shadow-md shadow-sm md-4`}
          sx={{
            maxWidth: 550,
            height: "130px",
            borderRadius: theme.shape.borderRadius,
            boxShadow:
              "0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 6px rgba(0, 0, 0, 0.1)",
            margin: "8px",
          }}
        >
          {showDescFromBookingText && (
            <div
              style={{
                float: "right",
              }}
            >
              <Button onClick={toogleVehicleInfoCardShowingStatus}>
                <p
                  className="text-md capitalize text-black"
                  style={{ color: secondaryColor }}
                >
                  Info
                </p>
              </Button>
            </div>
          )}
          <div className="w-full h-full">
            <div
              className="flex flex-row items-center text-sm"
              style={{
                marginLeft: "6px",
                height: "55px",
                marginTop: "9px",
              }}
            >
              {iconUrl != "#" && appSettings?.showHideExtrasImages && (
                <img
                  src={iconUrl}
                  className="aspect-square"
                  style={{
                    width: "10%",
                    marginLeft: isDesktopScreen ? "6px" : "2px",
                  }}
                  alt={""}
                ></img>
              )}
              {appSettings?.showOptionalCodeFromTextRes ? (
                <span
                  className="font-bold break-words"
                  style={
                    value > 0
                      ? { color: secondaryColor, padding: "2%" }
                      : { padding: "2%" }
                  }
                >
                  {optionalObject?.description || optionName}
                </span>
              ) : showOptionalCode ? (
                <span
                  className="font-bold break-words"
                  style={
                    value > 0
                      ? { color: secondaryColor, padding: "2%" }
                      : { padding: "2%" }
                  }
                >
                  {optionName}
                </span>
              ) : (
                ""
              )}

              {showOptionalDescription && (
                <span
                  className="font-bold break-words"
                  style={
                    value > 0
                      ? { color: secondaryColor, padding: "2%" }
                      : { padding: "2%" }
                  }
                >
                  {details}
                </span>
              )}
              {!showOptionalCode &&
                !showOptionalDescription &&
                !appSettings?.showOptionalCodeFromTextRes && (
                  <span
                    className="font-bold break-words"
                    style={
                      value > 0
                        ? { color: secondaryColor, padding: "2%" }
                        : { padding: "2%" }
                    }
                  >
                    {optionName}
                  </span>
                )}
            </div>
            <div
              className="flex flex-row"
              style={{
                justifyContent: "space-between",
                marginTop: !isSmallScreen ? marginTopStyle : "0px",
                marginLeft: isDesktopScreen ? "3px" : "undefined",
              }}
            >
              <span
                className="whitespace-nowrap"
                style={
                  {
                    color: "black",
                    fontWeight: "normal",
                    marginLeft: !isSmallScreen ? "5px" : "0px",
                    marginTop: marginTopStyle1,
                  } && value > 0
                    ? {
                        color: secondaryColor,
                        marginLeft: "8px",
                        marginTop: "15px",
                      }
                    : {
                        marginLeft: isDesktopScreen ? "8px" : "10px",
                        marginTop: isDesktopScreen ? "15px" : "17px",
                      }
                }
              >
                {!doNotShowOptionalPrice && (
                  <>
                    {defaultCurrency ||
                      formatPriceWithCurrencySymbol(
                        BookingGetters.getCurrency()
                      ).symbol}{" "}
                    {showDailyPriceForInsuranceAndExtras ? (
                      <>
                        {(
                          parseFloat(pricePerDayInUSD) / approximateDays
                        ).toFixed(2)}
                        <span>{translate("/day")}</span>
                      </>
                    ) : (showDailyPriceOrNegotiableDailyPrice &&
                        isDailyPrice) ||
                      isNegotiableDaily ? (
                      <>
                        {(
                          parseFloat(pricePerDayInUSD) / approximateDays
                        ).toFixed(2)}
                        <span>{translate("/day")}</span>
                      </>
                    ) : (
                      <span>{pricePerDayInUSD}</span>
                    )}
                  </>
                )}
              </span>
              <div
                style={{
                  color: value > 0 ? selectedCardTextColor : "",
                  height: "100px",
                  marginRight: !isSmallScreen ? "18px" : "8px",
                  marginBottom: "5px",
                  marginTop: isDesktopScreen ? "0px" : marginTopStyle,
                }}
              >
                {value > 0 ? (
                  <>
                    <div className="flex flex-row">
                      <CheckCircleOutlined
                        style={{
                          color: secondaryColor,
                          marginTop: marginTopStyle,
                        }}
                      />
                      <AppButton
                        color={value > 0 ? "secondaryColor" : "primary"}
                        onClick={() => {
                          onDecrementClick();
                        }}
                        className="w-[5rem] h-[2rem] rounded-md ml-[15px]"
                        style={{
                          marginTop: marginTopStyle,
                          borderRadius: `${
                            appSettings?.buttonBorderRadius || 0
                          }px`,
                        }}
                      >
                        <p
                          className={`min-w-24 w-full h-full flex items-center justify-center capitalize font-normal`}
                          style={{
                            fontSize: "x-small",
                            fontFamily: fontFamilyStyle
                              ? fontFamilyStyle
                              : undefined,
                          }}
                        >
                          {extrasRemoveButtonLabel ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: extrasRemoveButtonLabel,
                              }}
                            />
                          ) : (
                            <span>{translate("Remove")}</span>
                          )}
                        </p>
                      </AppButton>
                    </div>
                  </>
                ) : (
                  <AppButton
                    color={value > 0 ? "secondaryColor" : "primary"}
                    onClick={() => {
                      onIncrementClick();
                    }}
                    className="w-[5rem] h-[2rem] rounded-md ml-[28px]"
                    style={{
                      marginTop: marginTopStyle,
                      borderRadius: `${appSettings?.buttonBorderRadius || 0}px`,
                    }}
                  >
                    <p
                      className={`min-w-24 w-full h-full flex items-center justify-center capitalize font-normal`}
                      style={{
                        fontSize: "x-small",
                        fontFamily: fontFamilyStyle,
                      }}
                    >
                      {extrasSelectButtonLabel ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: extrasSelectButtonLabel,
                          }}
                        />
                      ) : (
                        <span>{translate("Select")}</span>
                      )}
                    </p>
                  </AppButton>
                )}
              </div>
            </div>
          </div>
        </Card>
      )}

      {showInfo && (
        <div
          style={{
            marginTop: "15px",
            width: "93%",
            marginLeft: "15px",
          }}
          className="absolute z-10 top-0 left-0 animate__animated animate__zoomIn"
        >
          <Card
            sx={{
              marginTop: "17px",
              maxWidth: 550,
              borderRadius: theme.shape.borderRadius,
              boxShadow:
                "0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 6px rgba(0, 0, 0, 0.1)",
              margin: "9px",
              height: "130px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "4px",
              }}
            >
              <Button
                style={{ paddingRight: "0px" }}
                className="w-1/5 flex justify-end"
                onClick={() => {
                  toogleVehicleInfoCardShowingStatus();
                }}
              >
                {appSettings?.hideCloseLabelWithCrossIcon ? (
                  <div
                    className="cross-icon"
                    style={
                      {
                        "--cross-color": secondaryColor,
                        marginRight: isDesktopScreen ? "-10px" : "undefined",
                      } as React.CSSProperties
                    }
                  />
                ) : (
                  <span style={{ paddingRight: "30px" }}>
                    {translate("Close")}
                  </span>
                )}
              </Button>
            </div>
            <div
              style={{
                justifyContent: "space-between",
                margin: "10px",
                marginTop: !appSettings?.hideCloseLabelWithCrossIcon
                  ? "0px"
                  : "10px",
                marginRight: 0,
                alignItems: isDesktopScreen ? "baseline" : undefined,
              }}
            >
              <div
                className={"text-black text-sm"}
                style={{
                  marginRight: "9px",
                  width: "95%",
                }}
              >
                {optionalBody}
              </div>
            </div>
          </Card>
        </div>
      )}
    </>
  );
}
export { VehicleExtrasWithInfo as default };
